<p-multiSelect
    [id]="id()"
    [ngModel]="isLoading() ? [] : selectedInventoryTransactionTypeKeys()"

    [options]="options()"
    optionLabel="inventoryTransactionTypeName"
    optionValue="inventoryTransactionTypeKey"
    dataKey="inventoryTransactionTypeKey"

    [placeholder]="isLoading() ? 'Loading transaction types...' : placeHolder()"
    [loading]="isLoading()"
    [showClear]="true"

    [disabled]="isDisabled()"
    [invalid]="isInvalid()"

    (ngModelChange)="onModelChange($event)"
    (onBlur)="blur.emit()"

    fluid
>
</p-multiSelect>
